import { Result } from 'antd';
import {FormattedMessage } from 'react-intl';
import {esES} from '../locales/es-ES';

const ExceptionPage = (props:any) =>{
    const {status, ticket}=props;
    const defaultMessageES = esES[`exception.message.${status}.subtitle`];
    return (<Result
    status={status}
    title={<FormattedMessage
      id = {`exception.message.${status}.title`}
      defaultMessage='' />}
    subTitle={<><FormattedMessage
      id ={`exception.message.${status}.subtitle`}
      defaultMessage={defaultMessageES}
    /> <b>{ticket}</b>. <FormattedMessage id='exception.message.default.thank' defaultMessage='Gracias' /></>}
  />)
}

export default ExceptionPage